import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { MoneyService } from 'src/app/Service/Money/Money.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-MoneyAdd',
  templateUrl: './MoneyAdd.component.html',
  styleUrls: ['./MoneyAdd.component.scss']
})
export class MoneyAddComponent implements OnInit {

  constructor(
    private Money_Service:MoneyService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewMoney=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(1125).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewMoney:FormGroup;

  get_Form_Title(){
    return this.AddNewMoney.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewMoney(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=0
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.Money_Service.AddMoney(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewMoney.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }
}
